import * as React from 'react';
import { Attribute } from '../../../Model/Attribute';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { UnitFormatter } from '../../../Service/UnitFormatter';
import { CombinedRangeFilter } from '../../Filter/CombinedRangeFilter';
import { DropdownFilter } from '../../Filter/DropdownFilter';
import { OptionsCollection } from '../../Filter/OptionsCollection';
import { RangeSliderFilter } from '../../Filter/RangeSliderFilter';
import { Trans } from '../../Trans';
import { AbstractFilterSectionView, FilterSectionViewProps } from '../AbstractFilterSectionView';
import { FilterInfo } from '../FilterInfo';
import { ForceSensorHelper } from './ForceSensorHelper';

interface FilterViewProps extends FilterSectionViewProps {
}

export class ForceSensorFilterView extends AbstractFilterSectionView<FilterViewProps> {
    private readonly unitFormatter: UnitFormatter;

    constructor(props: Readonly<FilterViewProps>) {
        super(props);
        this.unitFormatter = new UnitFormatter();
        this.prepareHandleLabel = this.prepareHandleLabel.bind(this);
    }

    public render() {
        const props = this.props;
        const allProducts = props.allProducts;

        return <div className="pf-filter-container">
            <div className="pf-filter-section">
                <div className="row">
                    <div className="pf-filter-wrapper -wide">
                        <div className="pf-filter-header"><Trans>Bauart</Trans></div>
                        <DropdownFilter filter={this.getFilter('Lagerung_Welle')}
                                        onChange={this.handleChange}
                                        options={this.collectAvailable('Lagerung_Welle')}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header pf-filter-nominal-force"><Trans>Nennkraft</Trans></div>
                        <CombinedRangeFilter filter={this.getFilter('Nennkraft')}
                                             logarithmic={true}
                                             snapToOption={true}
                                             onChange={this.handleChange}
                                             prepareHandleLabel={this.prepareHandleLabel}
                                             options={this.collectPower(allProducts)}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header">
                            <Trans id="Wellen_oder_Achsdurchmesser">Wellen- /Achsdurchmesser</Trans>
                        </div>
                        <RangeSliderFilter filter={this.getFilter('Lagerinnendurchmesser')}
                                           onChange={this.handleChange}
                                           options={this.collectAxisDiameter(allProducts)}/>
                    </div>
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Walzendurchmesser</Trans></div>
                        <div className="pf-filter-info"><Trans>Bei einseitiger Befestigung</Trans></div>
                        <RangeSliderFilter filter={this.getFilter('Walzendurchmesser_MW')}
                                           onChange={this.handleChange}
                                           options={this.collectRollerDiameter(allProducts)}/>
                    </div>
                    {/*
                    <div className="pf-filter-wrapper">
                        <div className="pf-filter-header"><Trans>Walzenlänge</Trans></div>
                        <div className="pf-filter-info"><Trans>Bei einseitiger Befestigung</Trans></div>
                        <RangeSliderFilter filter={this.getFilter('Walzenlaenge_MW')}
                                           onChange={this.handleChange}
                                           options={this.collectRollerLength(allProducts)}/>
                    </div>
                    */}
                </div>
            </div>
            <FilterInfo {...this.props}/>
        </div>;
    }

    private collectPower(products: ProductInterface[]): OptionsCollection<number> {
        return OptionsCollection.fromAttributesArray(this.collectPowerAttributesOfProducts(products));
    }

    private collectPowerAttributesOfProducts(products: ProductInterface[]): Attribute[] {
        return products.flatMap(product => ForceSensorHelper.powerCollectAttributesOfProduct(product));
    }

    private collectAxisDiameter(products: ProductInterface[]): OptionsCollection<number> {
        return OptionsCollection.fromAttributesArray(
            AttributeUtility.childAttributesForKeyFiltered(products, 'Lagerinnendurchmesser')
        );
    }

    private collectRollerDiameter(products: ProductInterface[]): OptionsCollection<number> {
        return OptionsCollection.fromAttributesArray(
            products.flatMap(product => ForceSensorHelper.rollerDiameterCollectAttributesOfProduct(product))
        );
    }

    // noinspection JSUnusedLocalSymbols
    private collectRollerLength(products: ProductInterface[]) {
        return OptionsCollection.fromAttributesArray(
            products.flatMap(product => ForceSensorHelper.rollerLengthCollectAttributesOfProduct(product))
        );
    }

    private prepareHandleLabel(value: number): string {
        return this.unitFormatter.formatNumber(value, 'N');
    }
}
